import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import menudown from "../src/assets/images/mobile-menu-downarrow.svg";
import menuup from "../src/assets/images/menuup.svg";
import { useTranslation } from "react-i18next";
import SubCategory from "../src/Json/SubCategory.json";
import brands from "../src/Json/Brand.json";
function LibasMenuSale({
  toggleCategory,
  expandedCategory,
  activeFilter,
  setHide,
  setActiveFilter,
  selectedPageNull,
  categoryContainerVariants,
  subcategoryItemVariants,
  navigateToCategory,
  toggleSubcategory,
  expandedSubcategories,
  nestedMenuVariants,
  nestedItemVariants,
}) {
  const { i18n, t } = useTranslation();
  return (
    <div
      className="category-menu"
      style={{
        color: "#404040",
        fontSize: "14px",
      }}
    >
      {/* Sale */}
      <div className="category-item mt-3">
        <motion.div
          className="d-flex justify-content-between align-items-center p-2 px-3"
          onClick={() => toggleCategory("Sale")}
          style={{
            borderBottom:
              expandedCategory === "Sale" ? "none" : "1px solid #dee2e6",
            borderBottomColor: expandedCategory === "Sale" ? "#333" : "#eee",
            borderBottomWidth: expandedCategory === "Sale" ? "2px" : "1px",
            cursor: "pointer",
          }}
        >
          <Link
            to="/products?topic=pricedrops&"
            className="titlemega"
            style={{
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (activeFilter === "Sale") {
                setHide(true);
                return;
              } else {
                setActiveFilter("Sale");
                setHide(true);
                selectedPageNull();
              }
            }}
          >
            <motion.span
              className=""
              style={{
                color: "#BC1010",
                fontWeight: expandedCategory === "Sale" ? "500" : "400",
                textDecoration:
                  expandedCategory === "Sale" ? "underline" : "none",
              }}
              whileHover={{ scale: 1.02 }}
            >
              {t("Sale")}
            </motion.span>
          </Link>

          {/* Animated arrow icon */}
          {/* <motion.div
            animate={{ rotate: expandedCategory === "mens" ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src={expandedCategory === "Sale" ? menuup : menudown}
              alt="menudown"
            />
          </motion.div> */}
        </motion.div>
      </div>
    </div>
  );
}

export default LibasMenuSale;
